<template>
  <main role="ChangeOrder">
    <div class="row">
      <!-- <div class="col-md-12"> -->
      <div class="card">
        <div class="card-header">
          <h5 class="card-title">List Perubahan Pesanan</h5>
          <!-- Button trigger modal -->
        </div>

        <!-- <div class="card-body"> -->
        <template>
          <ChangeOrderTable />
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import ChangeOrderTable from "./ChangeOrderTable.vue";
export default {
  components: {
    ChangeOrderTable,
  },
};
</script>

<style>
.modal-content {
  background-color: rgb(245, 245, 245);
}
</style>